import { useMutation } from "@tanstack/react-query";
import { getPayrollAgenticAPI } from "../../generated/core-api";
import type { ExportAllThreadsCsvParams } from "../../generated/core-api";

export function useExportThreadsCsv() {
  const api = getPayrollAgenticAPI();

  return useMutation({
    mutationFn: async (params?: ExportAllThreadsCsvParams) => {
      const response = await api.exportAllThreadsCsv(params);
      return response;
    },
    onSuccess: (data, variables) => {
      // Create a blob from the CSV data and trigger download
      if (typeof data !== "string") {
        console.error("Exported data is not a string. Cannot create CSV file.", data);
        return;
      }
      const blob = new Blob([data], { type: "text/csv" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;

      // Generate filename with current timestamp
      const timestamp = new Date().toISOString().split("T")[0];
      const fromDate = variables?.from_created_at
        ? `_from_${variables.from_created_at.split("T")[0]}`
        : "";
      const toDate = variables?.to_created_at
        ? `_to_${variables.to_created_at.split("T")[0]}`
        : "";
      link.download = `threads_export_${timestamp}${fromDate}${toDate}.csv`;

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    },
  });
}
